import { TimesheetLine } from '../../../domain/timesheets-domain';
import dayjs, { Dayjs } from 'dayjs';
import { DateFormats } from '../../../constants/datetime.constants';

/**
 * Returns true if the total hours for the given employee & date (with the
 * prospective edit applied to `entryNo`) is <= 24.
 */
export function isValidDailyTotalWithEdit(
  lines: TimesheetLine[],
  entryDate: Dayjs,
  employeeNo: string | null,
  editedEntryNo: number,
  editedDuration: number,
  dateFormat: string = DateFormats.DATE_YEAR_MONTH_DAY_KABOB,
): boolean {
  const targetDate = dayjs(entryDate).format(dateFormat);

  const totalForDay = lines.reduce((sum, line) => {
    if (line.activityDate !== targetDate || line.employeeNo !== employeeNo) return sum;
    const time = line.entryNo === editedEntryNo ? editedDuration : line.totalTime;
    return sum + time;
  }, 0);

  return totalForDay <= 24;
}
